import type { CSSProperties } from 'react';

interface Props {
  disableBreadcrumbs?: boolean;
  isSchedulePage?: boolean;
  isCalendarPage?: boolean;
  isClientCardPage?: boolean;
  isProfilePage?: boolean;
  colorBgContainer: string;
  disableContentStyles?: boolean;
}

export const getContentStyle = ({
  disableBreadcrumbs,
  isSchedulePage,
  isCalendarPage,
  isClientCardPage,
  isProfilePage,
  colorBgContainer,
  disableContentStyles,
}: Props) => {
  if (disableContentStyles) {
    return {};
  }

  if (disableBreadcrumbs) {
    return isCalendarPage ? { overflow: 'hidden' as const } : {};
  }

  const contentStyle: CSSProperties = {
    padding: isCalendarPage
      ? '0px'
      : isClientCardPage
      ? '24px 0px 24px 24px'
      : '24px',
    minHeight: 280,
    background: isProfilePage ? 'transparent' : colorBgContainer,
    overflowY: isSchedulePage ? 'auto' : 'scroll',
  };

  return contentStyle;
};
